import { useQuery } from "@tanstack/react-query";

import {requestApi, requestFile} from "@api/baseApi";

export const useBaseQuery = (fn, axiosOptions, tanstackOptions = {}) => {
    return useQuery({
        queryKey: [axiosOptions.endpoint, axiosOptions.method, axiosOptions.data],
        queryFn: async () => await fn(axiosOptions),
        ...tanstackOptions,
    });
};

export const useBaseApiQuery = (axiosOptions, tanstackOptions) => {
    return useBaseQuery(requestApi, axiosOptions, tanstackOptions)
};

export const useBaseFileQuery = (axiosOptions, tanstackOptions) => {
    return useBaseQuery(requestFile, axiosOptions, tanstackOptions)
};

// Example Usage:
// Fetch user details (GET request)
// const { data, error, isLoading } = useBaseApiQuery(
//     { endpoint: "users/me" },
//     { staleTime: 60000, enabled: true }
// );    
  
// Upload file (POST request)
// const { data: fileData } = useBaseFileQuery(
//     { endpoint: "upload", method: "POST", data: fileObject },
//     { retry: false }
// );